function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.701,
    height: 19.681,
    viewBox: "0 0 25.701 19.681",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon ionic-ios-checkmark",
    d: "m36 14.51-2.1-2.16a.452.452 0 0 0-.334-.143.433.433 0 0 0-.334.143L18.67 27.018l-5.3-5.3a.461.461 0 0 0-.668 0l-2.124 2.124a.476.476 0 0 0 0 .68l6.684 6.684a2.114 2.114 0 0 0 1.4.68 2.215 2.215 0 0 0 1.384-.656h.012l15.954-16.04a.51.51 0 0 0-.012-.68z",
    transform: "translate(-10.434 -12.206)",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.bb4eefad500fa2e96a939b8c2e61e2d5.svg";
export { ForwardRef as ReactComponent };